import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component, EventEmitter, Input, Output, inject
} from '@angular/core';
import { DateRangePickerDesktopModalComponent } from './date-range-picker-desktop-modal/date-range-picker-desktop-modal.component';
import { SvgIconComponent } from '@components/svg-icon/svg-icon.component';
import { DateRangePickerService } from '../date-range-picker.service';
import { DATE_FORMAT_DEFAULT } from '@constants/date-format.constants';
import { LetDirective } from '@directives/app-let.directive';
import { FALLBACK_CULTURE } from '@constants/app.constants';

@Component({
  selector: 'app-date-range-picker-desktop',
  standalone: true,
  imports: [
    CommonModule,
    DateRangePickerDesktopModalComponent,
    SvgIconComponent,
    LetDirective,
  ],
  templateUrl: './date-range-picker-desktop.component.html',
  styleUrl: './date-range-picker-desktop.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateRangePickerDesktopComponent {
  @Input() firstDatePlaceholder = '';
  @Input() secondDatePlaceholder = '';
  @Input() skipText = '';
  @Input() noSkipText = '';
  @Input() withSkip = false;

  @Output() skipClick = new EventEmitter<void>();

  private dateRangePickerService = inject(DateRangePickerService);

  firstDate$ = this.dateRangePickerService.firstDateFromRange$;
  secondDate$ = this.dateRangePickerService.lastDateFromRange$;
  isOpen$ = this.dateRangePickerService.isOpen$;
  isSkipped$ = this.dateRangePickerService.isSkipped$;
  isSingleDate$ = this.dateRangePickerService.isSingleDate$;
  culture$ = this.dateRangePickerService.culture$;

  readonly DATE_FORMAT_DEFAULT = DATE_FORMAT_DEFAULT;
  readonly FALLBACK_CULTURE = FALLBACK_CULTURE;

  onOpenDesktopModal() {
    this.dateRangePickerService.onOpenModal();
  }

  onCloseDesktopModal() {
    this.dateRangePickerService.onCloseModal();
  }

  onFirstDateClick() {
    this.dateRangePickerService.onChangeActiveInput('first');
    this.dateRangePickerService.isSkipped$.next(false);
    this.onOpenDesktopModal();
  }

  onSecondDateClick() {
    this.dateRangePickerService.onChangeActiveInput('second');
    this.onOpenDesktopModal();
  }

  onSkipClick() {
    this.skipClick.emit();
  }
}
